<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="名称">
                    <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                </el-form-item>
<!--                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable placeholder="类型">
                        <el-option
                            v-for="item in types"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                    <el-form-item label="分类">
                    <el-select v-model="form.categoryId" clearable placeholder="分类">
                        <el-option
                            v-for="item in trainCategorys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="title"
                    label="题目" >
                </el-table-column>
                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.imgPath"
                            :lazy="true"
                            :preview-src="scope.row.imgPath"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
<!--                <el-table-column
                    min-width="120"
                    prop="typeName"
                    label="类型" >
                </el-table-column>-->
                <el-table-column
                    min-width="120"
                    prop="optName"
                    label="语言类型" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="categoryName"
                    label="分类" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagNames"></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="content"
                    label="任务描述" >
                </el-table-column>
                <el-table-column
                    min-width="100"
                    prop="questionCount"
                    label="题目总数" >
                </el-table-column>
                <el-table-column
                    min-width="100"
                    prop="difficulty"
                    label="难度" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    label="时间段">
                    <template slot-scope="scope">
                        {{scope.row.startTime}} - {{scope.row.endTime}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="260"
                >
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-c_center">
                        </div>
                        <div class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="getQuestion(scope.row)"
                                    :underline="false" ><i class="iconfont icon-wenjian font20"></i><b>训练题目管理</b></el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <TaskDrawer :item="taskItem" v-if="showTask" @close="showTask = false" @submit="loadData"></TaskDrawer>
    </div>
</template>

<style scoped>

</style>

<script>
    import TaskDrawer from "./TaskDrawer";
    export default {
        components: {
            TaskDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form: {
                    keywords: "",
                    enable: true,
                },
                showEdit: false,
                showChoose:false,
                showQuestion:false,
                showChooseTask:false,
                showTask:false,
                question: false,
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                trainCategorys:[],
                trainTags:[],
                types:[],
            }

        },
        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            chooseQuestion(item) {
                if(item.type == 1){ //== 1   题库类型
                    // this.chooseItem = {...item};
                    // this.showChoose = true;
                }else{//操作题类型 添加任务
                    this.chooseTaskItem = {...item};
                    this.showChooseTask = true;
                }
            },
            getQuestion(item) {
                if(item.type == 1){ //== 1   题库类型
                    // this.questionItem = {...item};
                    // this.showQuestion = true;
                }else{//操作题类型 添加任务
                    this.taskItem = {...item};
                    this.showTask = true;
                }
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;

            },
            modifyEnable(item) {
                if(item.questionCount == 0){
                    item.enable = false;
                    this.$showError("请绑定任务后开启");
                    return ;
                }
                this.$ajaxGet("/challengeRound/toggleEnable/" + item.id + "-" + item.enable);
            },
            loadData() {
                this.$ajaxPost("/challengeRound/list", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showQuestion = false;
                    this.showEdit = false;
                    this.showChoose = false;
                    this.showChooseTask = false;
                    this.showTask = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            del(item) {
                this.$ajaxGet("/challengeRound/del/" + item.id, data => {
                    this.loadData();
                })
            },
            loadTrainCategory() {
                this.$ajaxGet("/trainCategory/listOption/1", (data) => {
                     this.trainCategorys = data.result;
                })
            },
            loadTrainTag() {
                this.$ajaxGet("/trainCategory/listOption/2", (data) => {
                     this.trainTags = data.result;
                })
            },
            loadType() {
                this.$ajaxGet("/common/trainModuleType", (data) => {
                     this.types = data.result;
                })
            }

        },

        created() {
            this.loadData();
            this.loadTrainCategory();
            this.loadTrainTag();
            //this.loadType();
        }

    }
</script>
